import * as React from 'react';
import { FC } from 'react';
import locales from 'app/CasinoGames/locales';

const LimitWarning: FC<{ reason: string }> = ({ reason }) => {
  const l = locales();

  return (
    <div className="limit-warning rs-text-align_center">
      <p className="reason">{reason}</p>
      {l.limits_link_text_1} <a href="/player/limits">{l.limits_link_text_2}</a>
    </div>
  );
};

export default LimitWarning;
